exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "body{-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;text-rendering:optimizeLegibility}body,button,input,optgroup,select,textarea{font-family:gellixregular,sans-serif;font-size:1rem;letter-spacing:.03rem}strong,.strong,label{font-family:gellixbold,sans-serif}h1,.h1,h2,.h2,h3,.h3,h4,.h4,h5,.h5,h6,.h6{font-family:gellixregular,sans-serif;line-height:120%}h1,.h1{font-size:3.15rem}@media screen and (max-width: 90em){h1,.h1{font-size:2.75rem}}h2,.h2{font-size:2.35rem}@media screen and (max-width: 90em){h2,.h2{font-size:1.55rem}}.Text__disclaimer{color:#898a8d}", ""]);

// exports
